<script setup>
import { reactive, ref, watch } from 'vue'
import ModalDialog from './ModalDialog.vue'
import { validateOperator } from '../api/users'

const props = defineProps({
  open: Boolean,
  saving: Boolean,
  error: { type: String, default: '' },
})
const emit = defineEmits(['close', 'save'])
const form = reactive({ username: '', fullName: '', password: '' })
const validationError = ref('')
const revealPassword = ref(false)

watch(() => props.open, () => {
  Object.assign(form, { username: '', fullName: '', password: '' })
  validationError.value = ''
  revealPassword.value = false
})

function submit() {
  if (props.saving) return
  validationError.value = validateOperator(form)
  if (!validationError.value) emit('save', { ...form })
}
</script>

<template>
  <ModalDialog :open="open" title="Создать оператора" eyebrow="Доступ к CRM" @close="!saving && emit('close')">
    <form class="dialog-form" @submit.prevent="submit">
      <fieldset class="operator-fields" :disabled="saving">
        <label class="field">
          <span>Логин <b aria-hidden="true">*</b></span>
          <input v-model="form.username" type="text" name="operator_username" autocomplete="off" autocapitalize="none" spellcheck="false" maxlength="80" required autofocus placeholder="Например, operator1" />
        </label>
        <label class="field">
          <span>Имя</span>
          <input v-model="form.fullName" type="text" name="operator_full_name" autocomplete="off" maxlength="160" placeholder="Имя сотрудника" />
        </label>
        <label class="field">
          <span>Пароль <b aria-hidden="true">*</b></span>
          <span class="password-input">
            <input v-model="form.password" :type="revealPassword ? 'text' : 'password'" name="operator_password" autocomplete="new-password" minlength="8" maxlength="128" required placeholder="От 8 до 128 символов" aria-describedby="operator-password-help" />
            <button type="button" :aria-pressed="revealPassword" @click="revealPassword = !revealPassword">{{ revealPassword ? 'Скрыть' : 'Показать' }}</button>
          </span>
          <small id="operator-password-help" class="operator-help">Передайте логин и пароль сотруднику безопасным способом.</small>
        </label>
      </fieldset>

      <p class="operator-role"><strong>Роль: оператор.</strong> Создание, редактирование и отмена броней, просмотр занятости. Управление справочниками и складом недоступно.</p>
      <p v-if="validationError || error" class="form-error" role="alert">{{ validationError || error }}</p>

      <footer class="modal-actions">
        <button type="button" class="button button--ghost" :disabled="saving" @click="emit('close')">Отмена</button>
        <button type="submit" class="button button--primary" :disabled="saving">
          <span v-if="saving" class="button-spinner" aria-hidden="true" />
          {{ saving ? 'Создаём…' : 'Создать оператора' }}
        </button>
      </footer>
    </form>
  </ModalDialog>
</template>

<style scoped>
.operator-fields {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.operator-help,
.operator-role {
  color: var(--muted);
  font-size: 0.76rem;
  line-height: 1.5;
}

.operator-role {
  margin: 0 0 20px;
}

.operator-role strong {
  color: var(--ink);
}
</style>
